import { timeFormat, timeParse } from 'd3-time-format';
import { line, curveBasis as curve } from 'd3-shape';
import { extent, max, min } from 'd3-array';

import {
  scaleLinear,
  scaleTime,
} from 'd3-scale';


import raw from './data/data.json';
import { cnn_red } from './utils/colors';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: 10,
    right: isMobile ? 90 : 100,
    bottom: 20,
    left: isMobile ? 60 : 75,
  };

  console.log(raw);

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;
  const parser = timeParse('%Y'); // https://github.com/d3/d3-time-format;
  const keys = Object.keys(raw[0]).slice(1);

  const data = keys.map(id => ({ id, values: raw.map(d => ({ date: parser(String(d.year)), value: +d[id] })) }));

  const maxValue = max(data, d => max(d.values, v => v.value));
  const minValue = min(data, d => min(d.values, v => v.value));

  const x = scaleTime()
    .range([0, width])
    .domain(extent(raw.map(d => parser(String(d.year)))));

  const y = scaleLinear()
    .range([height, 0])
    .domain([0, 0.3]);

  // const xAxisConfig = {
  //   orientation: 'bottom',
  //   domain: extent(raw, d => parser(d.date)),
  //   range: [0, width],
  //   nice: false,
  // };

  // const yAxisConfig = {
  //   orientation: 'left',
  //   domain: [minValue, maxValue],
  //   range: [height, 0],
  //   nice: false,
  // };


  const path = line()
    .curve(curve)
    .x(d => x(d.date))
    .y(d => y(d.value));

  return {
    data,
    fmtYearAbbrev: timeFormat('%y'),
    fmtYearFull: timeFormat('%Y'),
    initialWidth,
    initialHeight,
    margins,
    height,
    path,
    width,
    x,
    y,
  };
}
